export default __webpack_public_path__ + "static/media/logo.040f39e0.svg";